import React, { memo, FC } from 'react'
import MonofulLogo from 'assets/svgs/monoful-logo-background-white.svg'
import MonofulLogoFullSize from 'assets/svgs/monoful-brand-white.svg'
import styles from './style.module.css'

type Props = {
  onClick: () => void
}

const BookingWorkRecordEntry: FC<Props> = ({ onClick }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.logo}>
          <img src={MonofulLogo} alt="hacobell logo" className={styles.logoImage} />
          <img src={MonofulLogoFullSize} alt="ハコベル トラック簿" className={styles.logoImageSp} />
          <span className={styles.logoText}>トラック簿</span>
        </div>
        <button
          type="button"
          className={styles.button}
          onClick={onClick}
        >
          作業打刻
        </button>
      </div>
    </div>
  )
}

export default memo(BookingWorkRecordEntry)
